import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(public-routes)/(auth-pages)/auth/sign-up/component/SignUpClient.tsx");
